import "../ws8/ws8.css";
import { RenderView } from "../ws8/render/RenderView";

/** Render (/renders/:renderId): QA of one render. Owned by WS8 (implementation in web/src/ws8/render). */
export function RenderPage() {
  return <RenderView />;
}
